module.exports = __webpack_public_path__ + "media/images/background-photo-1@1x-2fbf7852cb323056e3158f16224a76e1.png";